import { Grid, Typography } from "@mui/material";
import React from "react";
import { useFormContext } from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";
import config from "../../Config/clientConfig.json";
import WSDateField from "../../Components/DateField/WSDateField";
import WSRadioField from "../../Components/Radio/WSRadio";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";

export const CashierFilterCriteria: React.FC<any> = React.memo((props) => {
  const { register, control } = useFormContext();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={2}>
        <Typography>From Date</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSDateField
          id="fromdate"
          name="fromdate"
          label=""
          dateFormat="D/MM/YYYY"
          control={control}
          defaultValue={null}
          rules={{ required: false }}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>To Date</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSDateField
          id="todate"
          name="todate"
          label=""
          dateFormat="D/MM/YYYY"
          control={control}
          defaultValue={null}
          rules={{ required: false }}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>User</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSSelectField
          rules={{ required: true }}
          {...register("user")}
          id="user"
          control={control}
          defaultValue={"0"}
          label=""
          name="user"
          options={config.userConfig.staticOptionData}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>Order Type</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSSelectField
          rules={{ required: true }}
          {...register("ordertype")}
          id="ordertype"
          control={control}
          defaultValue={"0"}
          label=""
          name="ordertype"
          options={config.ordertypeConfig.staticOptionData}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSCheckBoxField
          id="showreceiptsummary"
          name="showreceiptsummary"
          label="Show Receipt Summary"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSCheckBoxField
          id="showpayment"
          name="showpayment"
          label="Show Payment With Other Currency"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSCheckBoxField
          id="showdiscountsummary"
          name="showdiscountsummary"
          label="Show Discount Summary"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSCheckBoxField
          id="showcategorysummary"
          name="showcategorysummary"
          label="Show Category Summary"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSCheckBoxField
          id="showprinted"
          name="showprinted"
          label="Show Printed By Information"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSCheckBoxField
          id="amountbeforediscount"
          name="amountbeforediscount"
          label="Amount Before Discount"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSCheckBoxField
          id="showordertype"
          name="showordertype"
          label="Show Order Type Summary"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSCheckBoxField
          id="showgrossamount"
          name="showgrossamount"
          label="Show Gross Amount"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
      <Grid item xs={12}>
        <WSSCheckBoxField
          id="inclueadvancepayment"
          name="inclueadvancepayment"
          label="Inclue Advance Order Payment"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
      <Grid item xs={12}>
        <WSSCheckBoxField
          id="showmiscsales"
          name="showmiscsales"
          label="Show Misc Sales/Payouts"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
    </Grid>
  );
});
